import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/home/home";

const AllRoutes = () => {
  return (
    <div>
      <Routes>
        <Route exact path="/" element={<Home />}></Route>
      </Routes>
    </div>
  );
};

export default AllRoutes;
